module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/user-card/user-card.component.scss
// module id = ./src/app/modules/backstage-module/components/user-card/user-card.component.scss
// module chunks = 9